"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteringChipsMenu = exports.useApplySelection = exports.useMultipleSelection = void 0;

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.is-array.js");

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _checkbox = _interopRequireDefault(require("./../checkbox"));

var _button = _interopRequireDefault(require("./../button"));

var _utils = require("./../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/** Hooks */
var useMultipleSelection = function useMultipleSelection() {
  var initialValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _React$useState = _react["default"].useState(initialValues),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedValues = _React$useState2[0],
      setSelectedValues = _React$useState2[1];

  var handleChangeSelections = function handleChangeSelections(values) {
    return function (_, checked) {
      var updatedValues;

      if (values.length === 1) {
        var index = selectedValues.indexOf(values[0]);
        updatedValues = selectedValues.includes(values[0]) ? [].concat(_toConsumableArray(selectedValues.slice(0, index)), _toConsumableArray(selectedValues.slice(index + 1))) : [].concat(_toConsumableArray(selectedValues), [values[0]]);
      } else {
        updatedValues = checked ? values : [];
      }

      setSelectedValues(updatedValues);
    };
  };

  var handleConfirmSelections = function handleConfirmSelections(values) {
    return setSelectedValues(values);
  };

  return [selectedValues, handleChangeSelections, handleConfirmSelections];
};

exports.useMultipleSelection = useMultipleSelection;

var useApplySelection = function useApplySelection() {
  var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _React$useState3 = _react["default"].useState(selected),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      finalSelection = _React$useState4[0],
      setApplySelection = _React$useState4[1];

  var handleApplySelections = _react["default"].useCallback(function () {
    setApplySelection(selected);
  }, [selected]);

  return [finalSelection, handleApplySelections];
};
/** Hooks */

/** Components */


exports.useApplySelection = useApplySelection;
var useStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    content: {
      overflow: 'auto',
      maxHeight: 200
    },
    menuItem: {
      paddingTop: 3,
      paddingBottom: 3
    },
    menuItemText: {
      paddingRight: 18
    },
    menuItemHeader: {
      borderBottom: "solid 1px ".concat(theme.palette.common.black),
      paddingTop: 3,
      paddingBottom: 3
    },
    menuItemBottom: {
      borderTop: "solid 1px ".concat(theme.palette.common.black),
      paddingTop: 20,
      paddingBottom: 20,
      display: 'flex',
      justifyContent: 'flex-end'
    }
  };
});

var getFilteringChipsMenu = function getFilteringChipsMenu(props) {
  var options = props.options,
      selected = props.selected,
      _props$allSelectionLa = props.allSelectionLabel,
      allSelectionLabel = _props$allSelectionLa === void 0 ? 'All' : _props$allSelectionLa,
      _props$applySelection = props.applySelectionLabel,
      applySelectionLabel = _props$applySelection === void 0 ? 'Apply' : _props$applySelection,
      onSelectChange = props.onSelectChange,
      onApplySelection = props.onApplySelection;
  var classes = useStyles();

  var applyChanges = function applyChanges() {
    onApplySelection();
    onSelectChange([]); // Initilize selection
  };

  var menuItems = /*#__PURE__*/_react["default"].createElement("div", {
    key: -2,
    className: classes.content
  }, options.map(function (name) {
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      className: classes.menuItem,
      key: name,
      value: name
    }, /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
      checked: selected && selected.indexOf(name) > -1,
      onChange: onSelectChange([name])
    }), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      className: classes.menuItemText,
      primary: name
    }));
  }));

  return [/*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    className: classes.menuItemHeader,
    key: 0,
    value: ""
  }, /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
    checked: selected.length === options.length,
    onChange: onSelectChange(options)
  }), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
    primary: allSelectionLabel
  })), menuItems, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    className: classes.menuItemBottom,
    key: -1,
    value: ""
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    onClick: applyChanges
  }, applySelectionLabel))];
};
/** Components */


exports.getFilteringChipsMenu = getFilteringChipsMenu;